import { store } from "../../../store/store";
import { doPost as OMSAPIPost } from "../api/OMSAPI";
import { getSelectedChemistStoreId } from "../chemist/ChemistStoreUtils";
import { CacheDataToRefresh } from "../subject-behaviour/CommonRxjsService";
import { getPuralStringWithCount, isChemistStoreLoaded, isObjectNotEmpty } from "../CommonUtils";

import { loaderModal } from "../AlertLoaderService";

import { IndiaRupee, MedicineDataVersion } from "../../constants/AppConstants";
import { ActiveOrderStatus, CancelOrderStatus, OrderStatusMap } from "../../constants/oms/OrderStatus";

import RefreshCacheAction from "../webapp-services/RefreshCache";
import { getDealMRP, getDealOfferPrice } from "../inventory/DealsUtils";

export const getOrderStatus = (orderData) => {
    var statusText = ''
    const orderStatus = orderData['status']
    if (orderStatus == 1 || orderStatus == 6) {
        const pharmacyStatus = orderData['pharmacies'] ? orderData['pharmacies'][0]['status'] : 0
        statusText = OrderStatusMap[orderStatus][pharmacyStatus]
    } else statusText = OrderStatusMap[orderStatus]
    orderData['orderStatus'] = statusText
    return statusText
}

export const isOrderActive = (orderData) => {
    let orderStatus = ''
    if (orderData['orderStatus'])
        orderStatus = orderData['orderStatus']
    else {
        orderStatus = getOrderStatus(orderData)
    }
    orderData['isActiveOrder'] = ActiveOrderStatus.indexOf(orderStatus) == -1 ? false : true
    return ActiveOrderStatus.indexOf(orderStatus) == -1 ? false : true
}

export const isOrderCancelled = (orderData) => {
    let orderStatus = ''
    if (orderData['orderStatus'])
        orderStatus = orderData['orderStatus']
    else {
        orderStatus = getOrderStatus(orderData)
    }
    return CancelOrderStatus.indexOf(orderStatus) == -1 ? false : true
}

export const setOrderStatus = (orderData) => {
    var orderStatus = getOrderStatus(orderData)
    return {
        ...orderData,
        orderStatus: orderStatus,
        isActiveOrder: isOrderActive(orderData),
        isCancelOrder: isOrderCancelled(orderData)
    }
}

export const getOrderItemsString = (orderDetails) => {
    var itemString = ''
    if (orderDetails.hasOwnProperty('prescription') &&
        isObjectNotEmpty(orderDetails['prescription'])) {
        itemString = getPuralStringWithCount(
            orderDetails['prescription']['orgImages'].length)
    } else {
        if (orderDetails.hasOwnProperty('medications') &&
            orderDetails['medications'].length != 0)
            itemString = itemString + orderDetails['medications'].map(function (item) {
                return item.name + " x " + item.quantity;
            }).join(", ");
        if (orderDetails.hasOwnProperty('products') &&
            orderDetails['products'].length != 0) {
            itemString = itemString.length ? itemString + ', ' : itemString
            itemString = itemString + orderDetails['products'].map(function (item) {
                return item?.productName ?? item?.name + " x " + item.quantity;
            }).join(", ");
        }
    }
    return itemString
}

export const getUnitPrice = (cartItem) => {
    let priceStr = ''
    if (cartItem['mmid']) {
        priceStr = cartItem['uPrice']
        if (!priceStr && isObjectNotEmpty(cartItem.mrp)) {
            const price = cartItem['mrp']['price'] ?? 0
            const unit = cartItem['mrp']['su'] ?? 1
            const priceEach = price / unit;
            priceStr = priceEach.toFixed(2)
        }
    } else if(!cartItem?.offerValue) {
        priceStr = '--'
    } else {
        const price = cartItem?.offerValue
        const unit = cartItem?.su ?? 1
        const priceEach = price / unit;
        priceStr = priceEach.toFixed(2)
    }
    if (!priceStr) return '--'
    const type = cartItem['dfSingular'] ?? ''
    if (type) return priceStr + '/' + type
    else return priceStr
}

export const getOfferPrice = (cartItem) => {
    let priceStr: any = 0
    if (cartItem['dealId'])
        priceStr = getDealOfferPrice(cartItem)
    else if(!cartItem['mrp']) 
        priceStr = 0;
    else if (cartItem['mrp']['price'])
        priceStr = cartItem['mrp']['price']
    return priceStr ? priceStr : '--'
}

export const getMRP = (cartItem) => {
    // if MRP is same as Offer price returing 0
    // or item is not deal item.
    let offerPrice = 0, mrp = 0
    if (cartItem['dealId']) {
        mrp = getDealMRP(cartItem)
        offerPrice = getDealOfferPrice(cartItem)
        if (offerPrice == mrp) mrp = 0
    }
    return mrp
}

export const getItemSavingPercent = (cartItem) => {
    return cartItem?.discount ?? cartItem?.dl ?? ''
}

export const sortOrderListAccTime = (orderList) => {
    orderList.sort((order1, order2) => {
        var timeStamp1 = 0
        var timeStamp2 = 0
        if (order1)
            if (order1['pharmacyData'] && order1['pharmacyData']['lpmat'])
                timeStamp1 = order1['pharmacyData']['lpmat']
            else timeStamp1 = order1['ts']
        if (order2)
            if (order2['pharmacyData'] && order2['pharmacyData']['lpmat'])
                timeStamp2 = order2['pharmacyData']['lpmat']
            else timeStamp2 = order2['ts']
        return timeStamp2 - timeStamp1
    })
    return orderList
}

export const isReorderAllowed = (orderData) => {
    if (orderData['isCancelOrder']) return false
    let chemistStoreLoaded = isChemistStoreLoaded()
    const reduxState = store.getState()
    if (chemistStoreLoaded) {
        var pharmcyId = getSelectedChemistStoreId(reduxState)
        if (pharmcyId == orderData['pharmacyData']['id']) {
            if (orderData?.medications &&
                orderData?.medications?.length &&
                orderData?.medicineDataVersion == MedicineDataVersion) {
                return true;
            } else if (orderData?.prescription &&
                orderData?.prescription?.orgImages) {
                return true
            } else return false;
        }
    } else if (orderData?.medications &&
        orderData?.medications?.length &&
        orderData?.medicineDataVersion == MedicineDataVersion) {
        return true;
    } else if (orderData?.prescription &&
        orderData?.prescription?.orgImages) {
        return true
    } else return false;

}

export const isRateOrderAllowed = (orderData) => {
    if (orderData['feedback']) {
        return false;
    } else return true;
}

export const refreshOrder = () => {
    let refreshList = [{
        name: RefreshCacheAction.refreshOrderAndEconsultData,
        requestData: { fetchOrders: true }
    }]
    CacheDataToRefresh.setRefreshList(refreshList)
}

export const getFileDownloadUrlList = (downloadTokenList, showAlertoader = true) => {
    loaderModal.setLoader(showAlertoader);
    const params = { downloadTokenList: downloadTokenList ?? [] }
    return OMSAPIPost('order/get_file_download_url', params).
        then((response: any) => {
            loaderModal.setLoader(false);
            if (response) return response['downloadURLList']
            else return []
        }, (err: any) => { loaderModal.setLoader(false); return [] })
}

export const getOrderFromID = (orderList: any[], orderId) => {
    var orderData = orderList[0];
    orderList.forEach((order: any) => {
        if (order['oid'] == orderId)
            orderData = order;
    })
    return orderData;
}